import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

/* only a window of five pages is drawn - the list panel is narrow and a full
   run of numbers wraps out of it */
const TicketPager = ({ page, pageCount, onChange }) => (
    <Pagination className="vp-tk-pager" listClassName="vp-tk-pager-list">
        <PaginationItem disabled={page <= 1}>
            <PaginationLink tag="button" type="button" onClick={() => onChange(page - 1)}>
                ‹
            </PaginationLink>
        </PaginationItem>
        {Array.from({ length: pageCount }, (_, i) => i + 1)
            .filter((p) => p >= page - 2 && p <= page + 2)
            .map((p) => (
                <PaginationItem key={p} active={p === page}>
                    <PaginationLink tag="button" type="button" onClick={() => onChange(p)}>
                        {p}
                    </PaginationLink>
                </PaginationItem>
            ))}
        <PaginationItem disabled={page >= pageCount}>
            <PaginationLink tag="button" type="button" onClick={() => onChange(page + 1)}>
                ›
            </PaginationLink>
        </PaginationItem>
    </Pagination>
);

export default TicketPager;
